import { APIModel } from 'app/state/api';
import { ApiCallModel } from 'app/state/api/interfaces';

const googleDriveAutomations: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_S2I_API}/gdrive-automation`),
};

export default googleDriveAutomations;
